<template>
  <v-card flat>
    <h1>{{ $t("application.education.title") }}</h1>
    <p>{{ $t("application.education.info") }}</p>
    <p>
      <b>
        {{ $t("application.education.info-important") }}
        <b class="text-decoration-underline">{{
          $t("application.education.info-important1")
        }}</b>
        {{ $t("application.education.info-important2") }}
      </b>
    </p>

    <!-- Choose reform -->
      <div class="mt-6">
        <h6 class="text-uppercase mb-4">{{ $t('application.reform.title') }}</h6>
        <v-select outlined
          v-model="reform"
          :items="reforms"
        />
      </div>

    <v-form v-if="loadData && computedCourses">
      <div v-for="(course, index) in computedCourses" :key="index">
        <div class="d-flex justify-space-between mt-7">
          <h6 class="text-uppercase">{{ course }}</h6>
          <span class="body-2 overline">{{ $t("labels.approved") }}</span>
        </div>
        <div
          v-for="(child, indexChild) in sortBy(courses[course], ['courseCode'])"
          :key="child.id"
        >
          <div class="d-flex justify-space-between">
            <div class="block justify-start">
              <div class="subtitle-1">{{ child.courseName }}</div>
              <span class="body-2"
                >{{ filterCredit(child.credit) }} {{ child.courseCode }}</span
              >
            </div>
            <div class="block justify-end mr-1">
              <v-spacer></v-spacer>

              <v-checkbox
                class="mt-2 marked-blue"
                v-model="chkGrade"
                :value="child.id"
              ></v-checkbox>
            </div>
          </div>
          <v-divider
            class="mt-n2 mb-2"
            :key="`divider-${indexChild}`"
            v-if="indexChild != sortBy(courses[course], ['courseCode']).length - 1"
          ></v-divider>
        </div>
      </div>

      <!-- Accept and continue -->
      <h4 class="mt-10">{{ $t("application.documents-confirmation") }}</h4>
      <div class="d-flex mt-4 ml-3" v-if="isNothingCheckboxVisible">
        <v-checkbox class="mt-0 marked-blue label-top" v-model="hasConfirmedNothing" :label="$t('application.documents-confirmation-checkbox-3')"></v-checkbox>
      </div>
      <div class="d-flex mt-1 ml-3">
        <v-checkbox class="mt-0 marked-blue label-top" v-model="hasConfirmedCourses" :label="$t('application.documents-confirmation-checkbox-1')"></v-checkbox>
        <!-- <p class="mt" @click="hasConfirmedCourses=!hasConfirmedCourses">{{ $t("application.documents-confirmation-checkbox-1") }}</p> -->
      </div>
      <div class="d-flex mt-1 mb-9 ml-3">
        <v-checkbox class="mt-0 marked-blue label-top" v-model="hasConfirmedLegal" :label="$t('application.documents-confirmation-checkbox-2')"></v-checkbox>
        <!-- <p @click="hasConfirmedLegal=!hasConfirmedLegal" >{{ $t("application.documents-confirmation-checkbox-2") }}</p> -->
      </div>
      <p>{{ $t('application.documents-confirmation-checkbox-explanation') }}</p>
    </v-form>
    <NextButton
      :isDisabled="isNextDisabled"
      class="mt-6"
      @click="clickUpload"
    >
      {{ getNextBtnText() }}</NextButton
    >
    <BottomNav @clicked="$emit('goToStep', '-1')" />
  </v-card>
</template>

<script>
import API from "@/services/api.js";
import { mapActions, mapGetters } from "vuex";
import { CompanyRoles } from "@/components/mixins";
import sortBy from "lodash/sortBy";
import cloneDeep from "lodash/cloneDeep";
import groupBy from "lodash/groupBy";
import BottomNav from "@/components/Application/BottomNav";
import NextButton from "@/components/Common/NextButton";
import ActionButton from "@/components/Common/ActionButton";
import _, { get } from "lodash";

export default {
  name: "ApplicationEducation",

  mixins: [CompanyRoles],

  components: {
    BottomNav,
    NextButton,
    ActionButton,
  },

  data() {
    return {
      courses: {},
      chkGrade: [],
      hasConfirmedCourses: false,
      hasConfirmedNothing: false,
      hasConfirmedLegal: false,
      valid: false,
      loadData: false,
      reform: 'Gy11',
      reforms: [
        'Gy11',
        'Gy25'
      ]
    };
  },

  computed: {
    ...mapGetters("currentuser", ["currentUser"]),
    ...mapGetters("application", ["currentStep", "selectedApplication"]),

    computedCourses() {
      return sortBy(Object.keys(this.courses), [
        (v) => {
          const order = { G: 1, P: 2, I: 3, F: 4 };
          return order[v.charAt(0)];
        },
      ]);
    },
    isNothingCheckboxVisible() {
      return _.uniq(Object.values(this.chkGrade).filter(Boolean)).length !== _.flatten(Object.values(this.courses)).length;
    },
    isNextDisabled() {
      if (!this.hasConfirmedCourses || !this.hasConfirmedLegal) {
        return true;
      }

      if (!this.isNothingCheckboxVisible) {
        return false;
      }

      return !this.hasConfirmedNothing;
    },
    selectedReform() {
      const currentReform = get(this, 'reform', null)
      return currentReform !== 'Gy11' ? currentReform : null
    }
  },

  watch: {
    selectedApplication: {
      handler: function () {
        this.init();
      },
      deep: true,
    },
    selectedReform(value) {
      this.application()
      this.updateSelectedApplication({ ...this.selectedApplication, highSchoolReform: value })
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions("application", ["setSelectedApplication", "updateSelectedApplication"]),

    //- Stunt to make imported funktion a this.func to be used in template
    sortBy: sortBy,
    init() {
      this.loadData = false;
      this.application()
      if (this.selectedApplication) {
        this.hasConfirmedCourses = this.selectedApplication.hasConfirmedCourses;
        this.hasConfirmedLegal = this.selectedApplication.hasConfirmedLegal;
      }
    },
    getNextBtnText() {
      if (this.selectedApplication && this.selectedApplication.isCompanyApplication) {
        return this.$t("tour.next");
      } else {
        return this.$t("btn.company-next-step");
      }
    },
    filterCredit(c) {
      if (c && Number(c) >= 0) return c + "" + this.$i18n.t("labels.points");
      else return "";
    },

    fetchCourses() {
      if (this.selectedApplication && this.selectedApplication.professionId > 0) {
        API.listProfessionCourses(this.selectedApplication.professionId)
          .then((response) => {
            this.courses = response.data;
            this.coursesList = cloneDeep(response.data);
            this.application();
          })
          .catch((error) => {
            console.log("get courses error", error);
          });
      }
    },

    clickUpload() {
      if (!(this.selectedApplication && this.selectedApplication.id)) return;

      let courses = [];

      let approvedCourses = _.uniq(this.chkGrade);
      approvedCourses.forEach((id) => {
        courses.push({
          id: id,
          applicationId: this.selectedApplication.id,
          courseId: id,
          approved: this.chkGrade.includes(id) ? true : null,
        });
      });

      API.updateApplication(this.selectedApplication.id, {
        data: {
          applicationCourses: courses,
          hasConfirmedCourses: this.hasConfirmedCourses,
          hasConfirmedLegal: this.hasConfirmedLegal,
          highSchoolReform: this.selectedReform
        },
      })
        .then(() => {
          API.getApplication(this.selectedApplication.id)
            .then((res) => {
              if (res && res.data) {
                this.updateSelectedApplication(res.data);
              }
            })
            .catch((err) => {console.log('There was an error:', err)});

          this.selectedApplication.isCompanyApplication
            ? this.$emit("goToStep", "+3")
            : this.$emit("goToStep", "+1");
        })
        .catch((error) => {
          this.$events.fire("showError", this.$t("errors.save-failure"));
          console.log("There was an error:", error);
        });
    },
    application() {
      if (!(this.selectedApplication && this.selectedApplication.id)) return;

      API.getApplication(this.selectedApplication.id, this.selectedReform)
        .then((res) => {
          if (res && res.data) {
            this.loadData = true;
            this.courses = []
            res.data.applicationCourses.forEach((element) => {
              if (get(element, 'course.reform', null) === this.selectedReform) {
                this.courses.push(element.course);

                if (element.approved) {
                  this.chkGrade = [...this.chkGrade, element.courseId];
                }

                const dismantlingWorker = get(this, 'selectedApplication.professionId', null) === 2045
                const applicationDocuments = get(this, 'selectedApplication.applicationDocuments', [])

                if ( dismantlingWorker && applicationDocuments.length && this.reform === 'Gy11' ) {
                  this.courses = this.courses.filter(c => get(c, 'groupName', null) === 'Inriktning')
                }
              }
            });

            this.courses = groupBy(this.courses, course => course.groupName)
          }
        })
        .catch((err) => {console.log('There was an error:', err)});
    },
  },
};
</script>
<style scoped lang="scss"></style>
